import { BrowserRouter, Routes, Route } from "react-router-dom";

import Portfolio from "./Portfolio"; // ✅ Correct path


import "./App.css";

function App() {
  return (
    <BrowserRouter>
    
      <Routes>
  
        <Route path="/" element={<Portfolio />} /> {/* ✅ Added */}
      </Routes>

      {/* ✅ Video appears on every page */}
    </BrowserRouter>
  );
}

export default App;